import React from "react";

import { useLocation } from "react-router-dom";

// import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
// import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";

import TagMeetingHeader from "../components/TagMeetingHeader";
import CardComponent from "../components/CardComponent";

const RegularizeMeetingMenu = () => {
  const location = useLocation();
  const date = location.state;
  const Data = [
    {
      heading: "Regularize meeting",
      content:
        "Log your daily meetings with brokers, dealers,advisors, banca partners, digital partners, and more.",
      icon: "/icons/Zuno star mobile app icon-03.png",
      redirectTo: "/regularize-meeting",
    },
    {
      heading: "Mark my day",
      content: "Regularize and mark your attendance",
      icon: "/icons/Zuno star mobile app icon-04.png",
      redirectTo: "/mark-day",
    },
  ];

  // const iconMapping = {
  //   HandshakeOutlinedIcon,
  //   AssignmentTurnedInOutlinedIcon,
  // };

  return (
    <>
      <TagMeetingHeader headerName="Regularize attendance" />
      {Data.map((item, index) => {
        // const IconComponent = iconMapping[item.icon];
        return (
          <CardComponent
            key={index}
            heading={item.heading}
            content={item.content}
            Icon={item.icon}
            redirectTo={item.redirectTo}
            date={date}
          />
        );
      })}
    </>
  );
};

export default RegularizeMeetingMenu;
